/**
 * デジタルサイネージ向けヘッダー用モジュール。
 * @module app/view/SignageHeader
 */
define([
    'module',
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dojo/dom',
    'dojo/dom-style',
    'dojo/topic',
    'dojo/text!./templates/SignageHeader.html',
    'idis/control/Locator',
    'idis/view/_IdisWidgetBase',
    'app/util/DateFormatter',
    // 以下、変数で受けないモジュール
    'idis/view/dialog/IdisDialog',
    'idis/view/form/MunicipalitySelectForm',
    'app/view/PopupAlert',
    'dijit/form/Select',
    'idis/view/form/GeocodingForm',
    'dijit/form/Form',
    'app/view/Menu'
], function (module, declare, lang, dom, domStyle, topic, template, Locator, _IdisWidgetBase, DateFormatter) {
    /**
     * ヘッダー用オブジェクト
     * @class Header
     */
    return declare(module.id.replace(/\//g, '.'), _IdisWidgetBase, /** @lends app/view/Header~Header# */ {
        // テンプレート文字列
        templateString: template,

        // ルート要素のCSSクラス
        baseClass: 'index-Header',

         // DOMを構築する
        buildRendering: function () {
            this.inherited(arguments);

        },

        // DOMの準備が完了してから呼ばれる
        postCreate: function () {
            this.inherited(arguments);
        },

        startup: function () {
            this.inherited(arguments);
            this.own(topic.subscribe('app/control/SignageControl::setSignageHeaderDisasterName',
                lang.hitch(this, function (payload) {
                    this.signageTitleDisasterName.innerHTML = payload;
                })
            ));
            // デジタルサイネージヘッダーのラベルを設定 
            this.own(topic.subscribe('app/control/SignageControl::setSignageHeaderLabel',
                lang.hitch(this, function (payload) {
                    // タイトル
                    this.signageTitle.innerHTML = payload.title;
                    if(payload.displayType === 1) {
                        domStyle.set(this.signageTitleDisaster, 'display', 'flex');
                    } else {
                        domStyle.set(this.signageTitleDisaster, 'display', 'none');
                    }
                    // 現在時刻
                    var now = DateFormatter.signageHeaderDateTime(new Date(), true);
                    this.signageTimestamp.innerHTML = now + '時点';
            })));

            // デジタルサイネージ表示画面でリロード時にはstartと同じ処理をする。
            const signage = sessionStorage.getItem("selectedSignage");
            if(signage){
                const payload = JSON.parse(signage);
                topic.publish('app/control/SignageControl::setSignageHeaderLabel',payload[0]);
            }
        },

        // 通常のヘッダーを表示
        toggleHeader: function() {
            // TODO index.htmlの要素をdom.byIdによる指定でスタイル設定しているが処理を変更したい
            domStyle.set(dom.byId("index-Header"), "display", '');
            domStyle.set(dom.byId("index-Signage-Header"), "display", 'none');
            domStyle.set(dom.byId("index-Signage-Header"), "height", '');
            domStyle.set(dom.byId("container"), "padding-top", '');
            domStyle.set(dom.byId("container"), "background-color", '');
        },

        /**
         * タイトル文字列がクリックされた際に呼ばれ、トップ画面へ遷移させる。
         * @param {MouseEvent} evt クリック・イベント
         */
        onTitleLinkClick: function (evt) {
            // ヘッダー切り替え
            this.toggleHeader();
            // デジタルサイネージ更新停止
            topic.publish('app/control/SignageControl::stop');
            // ブラウザーの遷移処理をキャンセル
            evt.preventDefault();
            // トップ画面以外にいる場合はトップ画面へ遷移
            if (Locator.getQuery().p) {
                // ページへ遷移
                Locator.pushState('?', true);
            }
        }

    });
});
